import { render, staticRenderFns } from "./carrierInfo.vue?vue&type=template&id=6b18fc83&scoped=true&"
import script from "./carrierInfo.vue?vue&type=script&lang=js&"
export * from "./carrierInfo.vue?vue&type=script&lang=js&"
import style0 from "./carrierInfo.vue?vue&type=style&index=0&id=6b18fc83&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b18fc83",
  null
  
)

export default component.exports